import { Injectable } from '@angular/core';
import { NavItem } from '../models/nav-item.model';

/** Heroicons 24×24 outline `path` `d` values — keep in sync with sidebar primary rail. */
export const SIDEBAR_ROUTE_ICONS = {
  dashboard:
    'M4 6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6zm10 0a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V6zM4 16a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2zm10 0a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-2z',
  keyModules:
    'M15.75 5.25a3 3 0 013 3m3 0a6 6 0 01-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H3.75v-2.81L14.595 8.595a2.25 2.25 0 011.578-.543m4.5 0a6 6 0 01-1.905 4.41l-2.1-2.1',
  usage:
    'M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z',
  /** Document with text lines — document configuration */
  configureDocument:
    'M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9z',
  /** Terminal / console — API & workflow playground */
  playground:
    'M6.75 7.5l3 2.25-3 2.25m4.5 0h3m-9 8.25h13.5A2.25 2.25 0 0 0 21 18V6a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 6v12a2.25 2.25 0 0 0 2.25 2.25z',
  profile: 'M16 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0zM12 14a7 7 0 0 0-7 7h14a7 7 0 0 0-7-7z',
  /** Code brackets — API integration guide */
  integration:
    'M14.25 9.75 16.5 12l-2.25 2.25m-4.5 0L7.5 12l2.25-2.25M6 20.25h12a2.25 2.25 0 0 0 2.25-2.25V6a2.25 2.25 0 0 0-2.25-2.25H6A2.25 2.25 0 0 0 3.75 6v12a2.25 2.25 0 0 0 2.25 2.25z',
  /** Stacked layers — IDP v2 typed endpoints */
  integrationV2:
    'M14.25 9.75 16.5 12l-2.25 2.25m-4.5 0L7.5 12l2.25-2.25M6 20.25h12a2.25 2.25 0 0 0 2.25-2.25V6a2.25 2.25 0 0 0-2.25-2.25H6A2.25 2.25 0 0 0 3.75 6v12a2.25 2.25 0 0 0 2.25 2.25z',
  /** Bell / notification — webhooks */
  webhooks:
    'M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0',
} as const;

export const NAV_ITEMS: NavItem[] = [];

/** Shell pages opened from the sidebar (or as the default landing) but not part of NAV_ITEMS. */
export const STANDALONE_SHELL_ROUTES: NavItem[] = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    icon: SIDEBAR_ROUTE_ICONS.dashboard,
    route: '/erp-dashboard',
  },
  {
    id: 'key-modules',
    label: 'Manage API Key',
    icon: SIDEBAR_ROUTE_ICONS.keyModules,
    route: '/api-key-integration',
  },
  { id: 'usage', label: 'Usage', icon: SIDEBAR_ROUTE_ICONS.usage, route: '/usage' },
  // {
  //   id: 'configure-document',
  //   label: 'Configure Document',
  //   icon: SIDEBAR_ROUTE_ICONS.configureDocument,
  //   route: '/configure-document',
  // },
  {
    id: 'integration',
    label: 'Integration',
    icon: SIDEBAR_ROUTE_ICONS.integrationV2,
    route: '/integration',
  },
  {
    id: 'webhooks',
    label: 'Webhooks',
    icon: SIDEBAR_ROUTE_ICONS.webhooks,
    route: '/webhooks',
  },
  // {
  //   id: 'integration-v1',
  //   label: 'Integration v1',
  //   icon: SIDEBAR_ROUTE_ICONS.integration,
  //   route: '/integration-v1',
  // },
  { id: 'profile', label: 'My Profile', icon: SIDEBAR_ROUTE_ICONS.profile, route: '/profile' },
];

@Injectable({ providedIn: 'root' })
export class NavService {
  readonly navItems = NAV_ITEMS;

  findItemByRoute(route: string): NavItem | undefined {
    for (const item of this.navItems) {
      if (item.route === route) return item;
      if (item.children) {
        const child = item.children.find((c) => c.route === route);
        if (child) return child;
      }
    }
    const matches = STANDALONE_SHELL_ROUTES.filter(
      (s) => s.route !== undefined && (s.route === route || route.startsWith(s.route + '/')),
    );
    const sorted = [...matches].sort((a, b) => (b.route?.length ?? 0) - (a.route?.length ?? 0));
    return sorted[0];
  }

  allLeafItems(): NavItem[] {
    const result: NavItem[] = [];
    for (const item of this.navItems) {
      if (item.children) result.push(...item.children);
      else result.push(item);
    }
    return result;
  }
}
